// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".latest-articles[data-v-23fa492c]{grid-template-columns:repeat(3,200px)}@media(max-width:767px){.latest-articles[data-v-23fa492c]{overflow-x:scroll}}@media(min-width:768px){.latest-articles[data-v-23fa492c]{-moz-column-gap:37px;column-gap:37px;grid-template-columns:repeat(3,1fr)}}h2[data-v-23fa492c]{font-size:13px;font-weight:600;letter-spacing:-.2px;line-height:17px;margin-bottom:10px;text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
